import React from "react";
import { Link } from "react-router-dom";

import { findArticle, findCategory } from "../../data/faqs/index";
import { ArrowRightIcon } from "./icons";

/**
 * "Yang paling sering ditanya": groups of three questions, each with a link to
 * its whole category. 3 / 2 / 1 columns. Groups come from data/home.js, whose
 * references are verified at build time, so a missing one here is skipped
 * rather than rendered as a dead link.
 *
 * Each group is a card and each question a row with a hairline and an arrow,
 * the same row the category page uses. As plain grey text the questions -- most
 * wrap to two lines -- ran into each other and did not read as links.
 */
const PopularQuestions = ({ groups }) => (
  <div className="hc-qa">
    {groups.map(group => {
      const category = findCategory(group.category);
      if (category === null) return null;

      const articles = group.articles.map(ref => findArticle(ref.category, ref.slug)).filter(Boolean);

      return (
        <section key={group.category} className="hc-qa__group">
          <h3 className="hc-qa__head">
            <span className="hc-qa__dot" aria-hidden="true" />
            {category.title}
          </h3>
          <ul className="hc-qa__list">
            {articles.map(article => (
              <li key={article.id}>
                <Link to={`/${article.id}`} className="hc-qa__q">
                  <span className="hc-qa__text">{article.title}</span>
                  <span className="hc-qa__arrow">
                    <ArrowRightIcon size={14} />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <Link to={`/${category.slug}`} className="hc-qa__all">
            Lihat semua {category.articles.length} artikel
          </Link>
        </section>
      );
    })}
  </div>
);

export default PopularQuestions;
